
import { Avatar, Badge, Button, Card, Dropdown, Flex, Image, Space, Tooltip, Typography } from 'antd'
import React, { useEffect, useState } from 'react'
import { SwitchAccount } from './SwitchAccount';
import { useNavigate } from 'react-router-dom';
import { actionsApi, checkAuthorization, domainUrl } from '../../../shared';
import { useDispatch, useSelector } from 'react-redux';

const UserDropdown = ()=> {
  const [ switchAccount , setSwitchAccount] = useState(false)
  const [loading, setLoading]= useState(false)

  const dispatch = useDispatch()
  const { profiledata } = useSelector(state => state?.ProfilegetApi)
  useEffect(() => {
      dispatch(actionsApi?.getUpdateProfile())
  }, [dispatch])

const logout = () => {
    setLoading(true)
    const {userToken}= checkAuthorization()
    var myHeaders = new Headers();
    myHeaders.append("Authorization", userToken)
    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    }
    fetch(domainUrl + '/logout', requestOptions)
    .then(response => response.json())
    .then(result => {
    if (result?.success)
        {
            localStorage.clear()
            window.location.href = '/'
        }
    else
        throw 'error'
    })
    .catch(() => {
        setLoading(false)
        localStorage.clear()
        window.location.href = '/'
    })
}

  const dropdownContent = (
    <Card className='text-black radius-12 shadow-d card-cs p-0'>
      <Space direction='vertical' className='w-100'>
        <Space>
          <img src="/assets/images/av-1.png" style={{width: 45,height:45,borderRadius:50}} alt="" />
          <Flex vertical gap={2}>
            <Typography.Text strong className='fs-13'>{profiledata?.firstName +' '+ profiledata?.lastName}</Typography.Text>
            <Typography.Text className='text-gray fs-13'>{profiledata?.email}</Typography.Text>
          </Flex>
        </Space>
        <Button className='btnsave radius-8 border0 w-100'
          loading={loading}
          onClick={logout}
        >
          Logout
        </Button>
      </Space>
    </Card>
);
  return (
    <div>
      <Dropdown
          overlay={dropdownContent}
          trigger={['click']}
          className='margin-top p-0'
      >
          <Button shape='circle' size='large' className='p-0' style={{overflow:'hidden'}}>
              <Image src='/assets/images/av-1.png' preview={false} width={40} />
          </Button>
      </Dropdown>
      <SwitchAccount 
          visible={switchAccount}
          onClose={()=>{setSwitchAccount(false)}}
        />
    </div>
  )
}

export {UserDropdown}